import Vue from 'vue';
import {
  checkBinding, sendSmsValidateWithAreaCode, validateSmsAndBinding, checkMemberBind, getOneToOneInfo, fastBindingCheck, fastBinding
} from '../../../services/crmService/signUpService';
import {
  getStoreDropdown
} from '../../../services/storeMapService/storeService';

import {
  getMissionSticker
} from '../../../services/stickerService/signUpService';
// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  storeDropdown: [],
  redirectPage: '',
};

// getters
const getters = {};

// actions
const actions = {
  // 驗證綁定狀態
  async checkBindingHandler() {
    const data = await checkBinding();
    return data;
  },
  // 傳送簡訊驗證
  async sendSmsValidateHandler({}, info) {
    const data = await sendSmsValidateWithAreaCode(info);
    return data;
  },
  // 驗證簡訊驗證碼
  async validateSmsAndBindingHandler({}, validateInfo) {
    const data = await validateSmsAndBinding(validateInfo);
    return data;
  },
  // 取得專門店下拉
  async getStoreDropdownHandler({ commit }, query) {
    const data = await getStoreDropdown(query);
    commit('setStoreDropdown', data.data);
  },
  // 檢查會員是否綁定及是否綁定CA
  async checkMemberBindHandler({}, bindingInfo) {
    const data = await checkMemberBind(bindingInfo);
    return data;
  },
  // 取得已綁定顧客的跳轉關鍵字
  async getOneToOneInfoHandler({}, bindingInfo) {
    const data = await getOneToOneInfo(bindingInfo);
    return data;
  },
  // 取得已綁定顧客的跳轉關鍵字
  async getMissionStickerHandler({}, bindingInfo) {
    const data = await getMissionSticker(bindingInfo);
    return data;
  },
  // 透過ecmid 快速綁定檢查
  async fastBindingCheckHandler({}, bindingInfo) {
    const data = await fastBindingCheck(bindingInfo);
    return data;
  },
  // 透過ecmid 快速綁定
  async fastBindingHandler({}, bindingInfo) {
    const data = await fastBinding(bindingInfo);
    return data;
  },
};

// mutations
const mutations = {
  setStoreDropdown(state, data) {
    Vue.set(state, 'storeDropdown', data.data);
  },
  setRedirectPage(state, data) {
    Vue.set(state, 'redirectPage', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
